import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { IOrderHistoryResult } from '../../../models/order';
import Modal, { IModalChildProps } from '../../common/modal';

import '../order-details/modals/modal-styles.css';

interface IOverLimitModal extends IModalChildProps {
    orderHistory: IOrderHistoryResult;
}

const OverLimitModal = ({ onClose, orderHistory }: IOverLimitModal) => {
    const intl = useIntl();
    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        id="closeModalCancelModal"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({
                            id: 'Close',
                        })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <p className="text-center modal-body-main">
                    <FormattedMessage
                        id="Over_500"
                        defaultMessage={`There are more than ${orderHistory.maxOrderCount} orders from the last 30 days.
                        To find a specific order select custom date range from the dropdown.`}
                        values={{ 0: orderHistory.maxOrderCount }}
                    />
                </p>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-info"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Close" defaultMessage="Close" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default OverLimitModal;
